var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table-component",
    {
      ref: "table",
      attrs: {
        tableDivId: _vm.tableDivId,
        "show-filter": false,
        data: _vm.fetchData,
        "table-class": "table",
      },
    },
    [
      _c("table-column", {
        attrs: {
          label: _vm.$t("pos.date"),
          "sort-as": "purchase_order_date",
          show: "formattedPurchaseOrderDate",
        },
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: {
          label: _vm.$t("pos.due_date"),
          "sort-as": "expiry_date",
          show: "formattedExpiryDate",
        },
      }),
      _vm._v(" "),
      _vm.userType == "anchor" || _vm.userType == "super_admin"
        ? _c("table-column", {
            attrs: { label: _vm.$t("pos.supplier") },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      row.supplier_stakeholder
                        ? _c("p", [
                            row.supplier_stakeholder.details.company &&
                            row.supplier_stakeholder.details.company.name
                              ? _c("span", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        row.supplier_stakeholder.details.company
                                          .name
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              4122532740
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.userType == "supplier" || _vm.userType == "super_admin"
        ? _c("table-column", {
            attrs: { label: _vm.$t("pos.customer") },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      row.buyer_stakeholder
                        ? _c("p", [
                            row.buyer_stakeholder.details.company.name
                              ? _c("span", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        row.buyer_stakeholder.details.company
                                          .name
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              1546390739
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$t("pos.status"), show: "status" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (row) {
              return [
                _c("span", [_vm._v(" " + _vm._s(_vm.$t("pos.status")))]),
                _vm._v(" "),
                _vm.userType == "supplier" && row.status == "SENT"
                  ? _c(
                      "span",
                      { class: "po-status-" + row.status.toLowerCase() },
                      [_vm._v(_vm._s(_vm.$t("general.received")))]
                    )
                  : _vm.userType == "anchor" || _vm.userType == "super_admin"
                  ? _c(
                      "span",
                      { class: "po-status-" + row.status.toLowerCase() },
                      [_vm._v(_vm._s(row.status))]
                    )
                  : row.status != "SENT"
                  ? _c(
                      "span",
                      { class: "po-status-" + row.status.toLowerCase() },
                      [_vm._v(_vm._s(row.status))]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$tc("pos.po", 1), show: "purchase_order_number" },
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$t("invoices.total"), "sort-as": "total" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (row) {
              return [
                _c("span", [_vm._v(" " + _vm._s(_vm.$t("pos.total")))]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$utils.formatMoney(
                        row.total,
                        row.supplier.account.currency
                      )
                    ),
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }